import React from "react";
import { ConfirmationModalContainer } from "../Modal/ConfirmationModalContainer";
import { getValue } from "../../utils/object.utils";

interface Props {
  open: boolean;
  onClose: () => unknown;
  handleResultRemove: () => unknown;
  selectedResultToRemove: any;
  isProcessingConfirmation: boolean;
}

export const RemoveResultModal = ({
  open,
  onClose,
  handleResultRemove,
  selectedResultToRemove,
  isProcessingConfirmation,
}: Props) => {
  const resultLabel = getValue(selectedResultToRemove, "label", "");
  const className = getValue(selectedResultToRemove, "className", "");

  const confirmationText = `Are you sure you want to remove  ${resultLabel} result for ${className}?`;

  return (
    <ConfirmationModalContainer
      show={open}
      onClose={onClose}
      onSubmit={handleResultRemove}
      isRemoving
      isProcessingConfirmation={isProcessingConfirmation}
    >
      <div>{confirmationText}</div>
    </ConfirmationModalContainer>
  );
};
